import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederHounDto from '../Models/VeilederHounDto';

const heltAr = 'a1-heltAr';
const ettSemester = 'a2-ettSemester';
const deltid = 'a3-deltid';

const aValg: RadioButtonValgModel<VeilederHounDto>[] = [
    {
        id: 'a1',
        value: heltAr,
        tekst: 'valgFulltidHeltAr',
    },
    {
        id: 'a2',
        value: ettSemester,
        tekst: 'valgFulltidEttSemester',
    },
    { id: 'a3', value: deltid, tekst: 'valgDeltidsutdanning' },
];

export default {
    a1_heltAr: heltAr,
    a2_ettSemester: ettSemester,
    a3_deltid: deltid,
    aValg,
};
